<template>
  <table class="striped admin-users-table">
    <caption v-html="caption" v-if="caption" />
    <colgroup>
      <col width="20%" />
      <col width="20%" />
      <col width="20%" />
      <col width="20%" />
      <col width="20%" />
    </colgroup>
    <thead>
      <tr>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Phone Number</th>
        <th>Organization</th>
        <th>Profile Permission</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="user in paginatedUsers"
        :key="user.id"
        :class="selectedId === user.id ? 'selected' : 'selectable'"
        @click="handleSelect(user)"
      >
        <td>{{ user.firstName }}</td>
        <td>{{ user.lastName }}</td>
        <td>
          {{ formatPhoneNumber(getPhoneNumber(user).number)
          }}{{
            getPhoneNumber(user).extension
              ? ` ext. ${getPhoneNumber(user).extension}`
              : ""
          }}
        </td>
        <td>{{ user.organization.name }}</td>
        <td>{{ user.role.title }}</td>
      </tr>
      <tr v-if="users.length === 0">
        <td class="no-records" colspan="5">
          There are currently no users in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="5">
          <icon-button
            name="prev"
            :disabled="!hasPrevPage"
            @click="goToPrevPage"
          />

          <icon-button
            name="next"
            :disabled="!hasNextPage"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("users")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
    users: {
      type: Array,
    },
  },

  methods: {
    getPhoneNumber(user) {
      return user?.phoneNumbers?.slice(-1)?.[0] ?? {};
    },
    handleSelect(user) {
      this.$emit("select", user);
    },
  },
};
</script>